import * as types from "../actions/types";

export const initialState = {
  currentGroup: "Home",
  currentStage: null,
  navigationWait: false,
  stageLeaving: false,
  loader: false,
  loaderProgress: 0,
  unityAnimation: "Home",
  backToParent: false
};

export default function(prevState = initialState, action) {
  switch (action.type) {
    case types.GO_TO_GROUP:
      return Object.assign({}, prevState, {
        currentGroup: action.currentGroup,
        navigationWait: true,
        backToParent: action.backToParent
      });
    case types.GO_BACK:
      return Object.assign({}, prevState, {
        backToParent: action.backToParent
      });
    case types.GO_TO_STAGE:
      return Object.assign({}, prevState, {
        currentStage: action.currentStage,
        navigationWait: true,
        stageLeaving: false
      });
    case types.UNSET_NAVIGATION_WAIT:
      return Object.assign({}, prevState, {
        navigationWait: false
      });
    case types.SET_NAVIGATION_WAIT:
      return Object.assign({}, prevState, {
        navigationWait: true
      });
    // case types.SET_SECONDS_SINCE_NAV:
    // 	return Object.assign({}, prevState, {
    // 		secondsSinceNav: action.secondsSinceNav,
    // 	});
    case types.SET_LOADER:
      return Object.assign({}, prevState, {
        loader: action.loader
      });
    case types.UNITY_SET_CONTENT:
      return Object.assign({}, prevState, {
        unityContent: action.unityContent
      });
    case types.UNITY_SET_ANIMATION:
      // console.log('in UNITY_SET_ANIMATION with action', action);
      return Object.assign({}, prevState, {
        unityAnimation: action.unityAnimation
      });
    case types.SET_LOADER_PROGRESS:
      return Object.assign({}, prevState, {
        loaderProgress: action.loaderProgress
      });
    default:
      return prevState;
  }
}
